// extracted by mini-css-extract-plugin
export var dropdownIcon = "_n9-6";
export var imgContainer = "_n9-3";
export var menuIcon = "_n9-5";
export var pillWrapper = "_n9-2";
export var pillsContainer = "_n9-1";
export var subscriptionCard = "_n9-0";
export var subscriptionLogo = "_n9-4";